import { useState } from 'react';
import { useSelector } from 'react-redux';
import { InteractionStatus } from "@azure/msal-browser";
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { Box, Button, Avatar, Card, CardContent } from '@mui/material';
import { formatPhoneNumber } from '../../common/utilities/CustomFormatUtil';
import { CommonModal } from '../../components';
import { b2cPolicies } from '../../auth/authConfig';
import '../../common/theme/ProfileTheme.scss';
import constants from '../../constants';

const MyProfileComponent = ({ contactData }) => {
  const ssoAgent = useSelector(state => state.agencyId);
  const contactInfo = contactData;
  const firstNameInitial = contactInfo.firstName.charAt(0);
  const lastNameInitial = contactInfo.lastName.charAt(0);
  const initials = `${firstNameInitial}${lastNameInitial}`;
  const [showModal, setShowModal] = useState(false);
  const isAuthenticated = useIsAuthenticated();
  const { inProgress, instance } = useMsal();

  const resetMFA = () => {
    if (isAuthenticated && inProgress === InteractionStatus.None) {
      instance.acquireTokenRedirect(b2cPolicies.authorities.editMFA);
    }
  }

  const toggleModal = () => {
    setShowModal(!showModal);
  }

  const handleAuthAction = async () => {
    if (isAuthenticated && inProgress === InteractionStatus.None) {
      instance.acquireTokenRedirect(b2cPolicies.authorities.editUserId);
    }
  };

  return (
    <Card className='profile-card'>
      <CardContent className='profile-content'>
        <Box className='profile-title'>My profile</Box>
        <Box className='profile-name avatar-list-item'>
          <Avatar className='user-avatar'>{initials}</Avatar>{contactInfo.firstName} {contactInfo.lastName}
        </Box>
        <hr className='divider' />
        <Box className='profile-subheader'>Contact information</Box>
        <Box className='profile-text'>
        This information is only used for AMsuite+. To update your phone number and email in Agency Management or declarations pages, please contact Producer Management at licensingandcontracts@amig.com.
        </Box>

        <Box className='profile-info-box'>
          <Box className='profile-info-content'>
            <Box className='profile-info-header'>Phone number</Box>
            <Box className='profile-info-value'>{formatPhoneNumber(contactInfo.mobilePhone)}</Box>
            <Button disableRipple className='reset-button' onClick={() => resetMFA()}>Change phone number</Button>
          </Box>

          <Box>
            <Box className='profile-info-header'>Login ID (Email)</Box>
            <Box className='profile-info-value'>{contactInfo.emailAddress}</Box>
            {!ssoAgent ? <Button disableRipple className='reset-button' onClick={() => setShowModal(true)}>Change Login ID (Email)</Button> : null }
          </Box>
        </Box>
        {showModal && (
          <CommonModal type={constants.changeLoginId} toggleModal={toggleModal} action={() => handleAuthAction()}/>
        )}  
      </CardContent>
    </Card>
  );
};

export default MyProfileComponent;
